export type ScenarioParams = { id: number; maxTime?: number }

export const getScenarioList = ({ id, maxTime = 1 }: ScenarioParams) => {
  return {
    url: `/api/proposals/for-delivery?deliveryId=${id}&max_time=${maxTime}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}
